export type CountryType = "tr" | "uk" | "us" | "ng" | "za" | "au" | "eu"

export type CountryOption = {
  code: CountryType
  label: string
  flag: string
}

// Priority countries shown at the top of the selector
export const priorityCountries: CountryOption[] = [
  { code: "tr", label: "Turkey", flag: "🇹🇷" },
  { code: "us", label: "United States", flag: "🇺🇸" },
  { code: "uk", label: "United Kingdom", flag: "🇬🇧" },
  { code: "eu", label: "Germany", flag: "🇩🇪" },
  { code: "eu", label: "Canada", flag: "🇨🇦" },
  { code: "au", label: "Australia", flag: "🇦🇺" }
]

// All other countries (alphabetically sorted), mapped to "eu" (IBAN) form
export const otherCountries: CountryOption[] = [
  { code: "eu", label: "Afghanistan", flag: "🇦🇫" },
  { code: "eu", label: "Albania", flag: "🇦🇱" },
  { code: "eu", label: "Algeria", flag: "🇩🇿" },
  { code: "eu", label: "Andorra", flag: "🇦🇩" },
  { code: "eu", label: "Angola", flag: "🇦🇴" },
  { code: "eu", label: "Antigua and Barbuda", flag: "🇦🇬" },
  { code: "eu", label: "Argentina", flag: "🇦🇷" },
  { code: "eu", label: "Armenia", flag: "🇦🇲" },
  { code: "eu", label: "Austria", flag: "🇦🇹" },
  { code: "eu", label: "Azerbaijan", flag: "🇦🇿" },
  { code: "eu", label: "Bahamas", flag: "🇧🇸" },
  { code: "eu", label: "Bahrain", flag: "🇧🇭" },
  { code: "eu", label: "Bangladesh", flag: "🇧🇩" },
  { code: "eu", label: "Barbados", flag: "🇧🇧" },
  { code: "eu", label: "Belarus", flag: "🇧🇾" },
  { code: "eu", label: "Belgium", flag: "🇧🇪" },
  { code: "eu", label: "Belize", flag: "🇧🇿" },
  { code: "eu", label: "Benin", flag: "🇧🇯" },
  { code: "eu", label: "Bhutan", flag: "🇧🇹" },
  { code: "eu", label: "Bolivia", flag: "🇧🇴" },
  { code: "eu", label: "Bosnia and Herzegovina", flag: "🇧🇦" },
  { code: "eu", label: "Botswana", flag: "🇧🇼" },
  { code: "eu", label: "Brazil", flag: "🇧🇷" },
  { code: "eu", label: "Brunei", flag: "🇧🇳" },
  { code: "eu", label: "Bulgaria", flag: "🇧🇬" },
  { code: "eu", label: "Burkina Faso", flag: "🇧🇫" },
  { code: "eu", label: "Burundi", flag: "🇧🇮" },
  { code: "eu", label: "Cabo Verde", flag: "🇨🇻" },
  { code: "eu", label: "Cambodia", flag: "🇰🇭" },
  { code: "eu", label: "Cameroon", flag: "🇨🇲" },
  { code: "eu", label: "Central African Republic", flag: "🇨🇫" },
  { code: "eu", label: "Chad", flag: "🇹🇩" },
  { code: "eu", label: "Chile", flag: "🇨🇱" },
  { code: "eu", label: "China", flag: "🇨🇳" },
  { code: "eu", label: "Colombia", flag: "🇨🇴" },
  { code: "eu", label: "Comoros", flag: "🇰🇲" },
  { code: "eu", label: "Congo", flag: "🇨🇬" },
  { code: "eu", label: "Costa Rica", flag: "🇨🇷" },
  { code: "eu", label: "Croatia", flag: "🇭🇷" },
  { code: "eu", label: "Cuba", flag: "🇨🇺" },
  { code: "eu", label: "Cyprus", flag: "🇨🇾" },
  { code: "eu", label: "Czech Republic", flag: "🇨🇿" },
  { code: "eu", label: "Denmark", flag: "🇩🇰" },
  { code: "eu", label: "Djibouti", flag: "🇩🇯" },
  { code: "eu", label: "Dominica", flag: "🇩🇲" },
  { code: "eu", label: "Dominican Republic", flag: "🇩🇴" },
  { code: "eu", label: "East Timor (Timor-Leste)", flag: "🇹🇱" },
  { code: "eu", label: "Ecuador", flag: "🇪🇨" },
  { code: "eu", label: "Egypt", flag: "🇪🇬" },
  { code: "eu", label: "El Salvador", flag: "🇸🇻" },
  { code: "eu", label: "Equatorial Guinea", flag: "🇬🇶" },
  { code: "eu", label: "Eritrea", flag: "🇪🇷" },
  { code: "eu", label: "Estonia", flag: "🇪🇪" },
  { code: "eu", label: "Eswatini", flag: "🇸🇿" },
  { code: "eu", label: "Ethiopia", flag: "🇪🇹" },
  { code: "eu", label: "Fiji", flag: "🇫🇯" },
  { code: "eu", label: "Finland", flag: "🇫🇮" },
  { code: "eu", label: "France", flag: "🇫🇷" },
  { code: "eu", label: "Gabon", flag: "🇬🇦" },
  { code: "eu", label: "Gambia", flag: "🇬🇲" },
  { code: "eu", label: "Georgia", flag: "🇬🇪" },
  { code: "eu", label: "Ghana", flag: "🇬🇭" },
  { code: "eu", label: "Greece", flag: "🇬🇷" },
  { code: "eu", label: "Grenada", flag: "🇬🇩" },
  { code: "eu", label: "Guatemala", flag: "🇬🇹" },
  { code: "eu", label: "Guinea", flag: "🇬🇳" },
  { code: "eu", label: "Guinea-Bissau", flag: "🇬🇼" },
  { code: "eu", label: "Guyana", flag: "🇬🇾" },
  { code: "eu", label: "Haiti", flag: "🇭🇹" },
  { code: "eu", label: "Honduras", flag: "🇭🇳" },
  { code: "eu", label: "Hungary", flag: "🇭🇺" },
  { code: "eu", label: "Iceland", flag: "🇮🇸" },
  { code: "eu", label: "India", flag: "🇮🇳" },
  { code: "eu", label: "Indonesia", flag: "🇮🇩" },
  { code: "eu", label: "Iran", flag: "🇮🇷" },
  { code: "eu", label: "Iraq", flag: "🇮🇶" },
  { code: "eu", label: "Ireland", flag: "🇮🇪" },
  { code: "eu", label: "Israel", flag: "🇮🇱" },
  { code: "eu", label: "Italy", flag: "🇮🇹" },
  { code: "eu", label: "Ivory Coast", flag: "🇨🇮" },
  { code: "eu", label: "Jamaica", flag: "🇯🇲" },
  { code: "eu", label: "Japan", flag: "🇯🇵" },
  { code: "eu", label: "Jordan", flag: "🇯🇴" },
  { code: "eu", label: "Kazakhstan", flag: "🇰🇿" },
  { code: "eu", label: "Kenya", flag: "🇰🇪" },
  { code: "eu", label: "Kiribati", flag: "🇰🇮" },
  { code: "eu", label: "Korea, North", flag: "🇰🇵" },
  { code: "eu", label: "Korea, South", flag: "🇰🇷" },
  { code: "eu", label: "Kosovo", flag: "🇽🇰" },
  { code: "eu", label: "Kuwait", flag: "🇰🇼" },
  { code: "eu", label: "Kyrgyzstan", flag: "🇰🇬" },
  { code: "eu", label: "Laos", flag: "🇱🇦" },
  { code: "eu", label: "Latvia", flag: "🇱🇻" },
  { code: "eu", label: "Lebanon", flag: "🇱🇧" },
  { code: "eu", label: "Lesotho", flag: "🇱🇸" },
  { code: "eu", label: "Liberia", flag: "🇱🇷" },
  { code: "eu", label: "Libya", flag: "🇱🇾" },
  { code: "eu", label: "Liechtenstein", flag: "🇱🇮" },
  { code: "eu", label: "Lithuania", flag: "🇱🇹" },
  { code: "eu", label: "Luxembourg", flag: "🇱🇺" },
  { code: "eu", label: "Madagascar", flag: "🇲🇬" },
  { code: "eu", label: "Malawi", flag: "🇲🇼" },
  { code: "eu", label: "Malaysia", flag: "🇲🇾" },
  { code: "eu", label: "Maldives", flag: "🇲🇻" },
  { code: "eu", label: "Mali", flag: "🇲🇱" },
  { code: "eu", label: "Malta", flag: "🇲🇹" },
  { code: "eu", label: "Marshall Islands", flag: "🇲🇭" },
  { code: "eu", label: "Mauritania", flag: "🇲🇷" },
  { code: "eu", label: "Mauritius", flag: "🇲🇺" },
  { code: "eu", label: "Mexico", flag: "🇲🇽" },
  { code: "eu", label: "Micronesia", flag: "🇫🇲" },
  { code: "eu", label: "Moldova", flag: "🇲🇩" },
  { code: "eu", label: "Monaco", flag: "🇲🇨" },
  { code: "eu", label: "Mongolia", flag: "🇲🇳" },
  { code: "eu", label: "Montenegro", flag: "🇲🇪" },
  { code: "eu", label: "Morocco", flag: "🇲🇦" },
  { code: "eu", label: "Mozambique", flag: "🇲🇿" },
  { code: "eu", label: "Myanmar (Burma)", flag: "🇲🇲" },
  { code: "eu", label: "Namibia", flag: "🇳🇦" },
  { code: "eu", label: "Nauru", flag: "🇳🇷" },
  { code: "eu", label: "Nepal", flag: "🇳🇵" },
  { code: "eu", label: "Netherlands", flag: "🇳🇱" },
  { code: "eu", label: "New Zealand", flag: "🇳🇿" },
  { code: "eu", label: "Nicaragua", flag: "🇳🇮" },
  { code: "eu", label: "Niger", flag: "🇳🇪" },
  { code: "ng", label: "Nigeria", flag: "🇳🇬" },
  { code: "eu", label: "North Macedonia", flag: "🇲🇰" },
  { code: "eu", label: "Norway", flag: "🇳🇴" },
  { code: "eu", label: "Oman", flag: "🇴🇲" },
  { code: "eu", label: "Pakistan", flag: "🇵🇰" },
  { code: "eu", label: "Palau", flag: "🇵🇼" },
  { code: "eu", label: "Panama", flag: "🇵🇦" },
  { code: "eu", label: "Papua New Guinea", flag: "🇵🇬" },
  { code: "eu", label: "Paraguay", flag: "🇵🇾" },
  { code: "eu", label: "Peru", flag: "🇵🇪" },
  { code: "eu", label: "Philippines", flag: "🇵🇭" },
  { code: "eu", label: "Poland", flag: "🇵🇱" },
  { code: "eu", label: "Portugal", flag: "🇵🇹" },
  { code: "eu", label: "Qatar", flag: "🇶🇦" },
  { code: "eu", label: "Romania", flag: "🇷🇴" },
  { code: "eu", label: "Russia", flag: "🇷🇺" },
  { code: "eu", label: "Rwanda", flag: "🇷🇼" },
  { code: "eu", label: "Saint Kitts and Nevis", flag: "🇰🇳" },
  { code: "eu", label: "Saint Lucia", flag: "🇱🇨" },
  { code: "eu", label: "Saint Vincent and the Grenadines", flag: "🇻🇨" },
  { code: "eu", label: "Samoa", flag: "🇼🇸" },
  { code: "eu", label: "San Marino", flag: "🇸🇲" },
  { code: "eu", label: "Sao Tome and Principe", flag: "🇸🇹" },
  { code: "eu", label: "Saudi Arabia", flag: "🇸🇦" },
  { code: "eu", label: "Senegal", flag: "🇸🇳" },
  { code: "eu", label: "Serbia", flag: "🇷🇸" },
  { code: "eu", label: "Seychelles", flag: "🇸🇨" },
  { code: "eu", label: "Sierra Leone", flag: "🇸🇱" },
  { code: "eu", label: "Singapore", flag: "🇸🇬" },
  { code: "eu", label: "Slovakia", flag: "🇸🇰" },
  { code: "eu", label: "Slovenia", flag: "🇸🇮" },
  { code: "eu", label: "Solomon Islands", flag: "🇸🇧" },
  { code: "eu", label: "Somalia", flag: "🇸🇴" },
  { code: "za", label: "South Africa", flag: "🇿🇦" },
  { code: "eu", label: "South Sudan", flag: "🇸🇸" },
  { code: "eu", label: "Spain", flag: "🇪🇸" },
  { code: "eu", label: "Sri Lanka", flag: "🇱🇰" },
  { code: "eu", label: "Sudan", flag: "🇸🇩" },
  { code: "eu", label: "Suriname", flag: "🇸🇷" },
  { code: "eu", label: "Sweden", flag: "🇸🇪" },
  { code: "eu", label: "Switzerland", flag: "🇨🇭" },
  { code: "eu", label: "Syria", flag: "🇸🇾" },
  { code: "eu", label: "Taiwan", flag: "🇹🇼" },
  { code: "eu", label: "Tajikistan", flag: "🇹🇯" },
  { code: "eu", label: "Tanzania", flag: "🇹🇿" },
  { code: "eu", label: "Thailand", flag: "🇹🇭" },
  { code: "eu", label: "Togo", flag: "🇹🇬" },
  { code: "eu", label: "Tonga", flag: "🇹🇴" },
  { code: "eu", label: "Trinidad and Tobago", flag: "🇹🇹" },
  { code: "eu", label: "Tunisia", flag: "🇹🇳" },
  { code: "eu", label: "Turkmenistan", flag: "🇹🇲" },
  { code: "eu", label: "Tuvalu", flag: "🇹🇻" },
  { code: "eu", label: "Uganda", flag: "🇺🇬" },
  { code: "eu", label: "Ukraine", flag: "🇺🇦" },
  { code: "eu", label: "United Arab Emirates", flag: "🇦🇪" },
  { code: "eu", label: "Uruguay", flag: "🇺🇾" },
  { code: "eu", label: "Uzbekistan", flag: "🇺🇿" },
  { code: "eu", label: "Vanuatu", flag: "🇻🇺" },
  { code: "eu", label: "Vatican City", flag: "🇻🇦" },
  { code: "eu", label: "Venezuela", flag: "🇻🇪" },
  { code: "eu", label: "Vietnam", flag: "🇻🇳" },
  { code: "eu", label: "Yemen", flag: "🇾🇪" },
  { code: "eu", label: "Zambia", flag: "🇿🇲" },
  { code: "eu", label: "Zimbabwe", flag: "🇿🇼" }
]

// Combined list: priority first, then others alphabetically
export const allCountries: CountryOption[] = [...priorityCountries, ...otherCountries]

// Legacy export for backward compatibility
export const countryOptions = priorityCountries

const countryMap: Record<string, CountryType> = {
  turkey: "tr",
  tr: "tr",
  "united kingdom": "uk",
  uk: "uk",
  "united states": "us",
  "united states of america": "us",
  us: "us",
  usa: "us",
  nigeria: "ng",
  ng: "ng",
  "south africa": "za",
  za: "za",
  australia: "au",
  au: "au"
}

export const resolveCountryType = (countryLabel?: string): CountryType => {
  if (!countryLabel) return "eu"
  const key = countryLabel.toLowerCase().trim()
  return countryMap[key] || "eu"
}

export const nigeriaBankOptions = [
  { label: "Access Bank", value: 1, value2: "Access Bank", bankCode: "044" },
  { label: "Citibank Nigeria", value: 2, value2: "Citibank Nigeria", bankCode: "023" },
  { label: "Ecobank Nigeria", value: 3, value2: "Ecobank Nigeria", bankCode: "050" },
  { label: "Fidelity Bank", value: 4, value2: "Fidelity Bank", bankCode: "070" },
  { label: "First Bank of Nigeria", value: 5, value2: "First Bank of Nigeria", bankCode: "011" },
  { label: "First City Monument Bank (FCMB)", value: 6, value2: "First City Monument Bank", bankCode: "214" },
  { label: "Guaranty Trust Bank (GTBank)", value: 7, value2: "Guaranty Trust Bank", bankCode: "058" },
  { label: "Heritage Bank", value: 8, value2: "Heritage Bank", bankCode: "030" },
  { label: "Keystone Bank", value: 9, value2: "Keystone Bank", bankCode: "082" },
  { label: "Polaris Bank", value: 10, value2: "Polaris Bank", bankCode: "076" },
  { label: "Stanbic IBTC Bank", value: 11, value2: "Stanbic IBTC Bank", bankCode: "221" },
  { label: "Standard Chartered Bank", value: 12, value2: "Standard Chartered Bank", bankCode: "068" },
  { label: "Sterling Bank", value: 13, value2: "Sterling Bank", bankCode: "232" },
  { label: "Union Bank of Nigeria", value: 14, value2: "Union Bank of Nigeria", bankCode: "032" },
  { label: "United Bank for Africa (UBA)", value: 15, value2: "United Bank for Africa", bankCode: "033" },
  { label: "Unity Bank", value: 16, value2: "Unity Bank", bankCode: "215" },
  { label: "Wema Bank", value: 17, value2: "Wema Bank", bankCode: "035" },
  { label: "Zenith Bank", value: 18, value2: "Zenith Bank", bankCode: "057" }
]

export const southAfricaBankOptions = [
  { label: "ABSA Bank", value: 1, value2: "ABSA Bank" },
  { label: "African Bank", value: 2, value2: "African Bank" },
  { label: "Bidvest Bank", value: 3, value2: "Bidvest Bank" },
  { label: "Capitec Bank", value: 4, value2: "Capitec Bank" },
  { label: "Discovery Bank", value: 5, value2: "Discovery Bank" },
  { label: "First National Bank (FNB)", value: 6, value2: "First National Bank" },
  { label: "Investec Bank", value: 7, value2: "Investec Bank" },
  { label: "Nedbank", value: 8, value2: "Nedbank" },
  { label: "Standard Bank", value: 9, value2: "Standard Bank" },
  { label: "TymeBank", value: 10, value2: "TymeBank" }
]

export const saAccountTypeOptions = [
  { label: "Cheque", value: 1, value2: "Cheque" },
  { label: "Savings", value: 2, value2: "Savings" }
]
